import { FILTERED_FIELDS } from "views/Constants";
const isFilteredField = (fieldName) => FILTERED_FIELDS.includes(fieldName);
export default isFilteredField;
